export default __webpack_public_path__ + "static/media/cheese-background.31465fd3.png";